import { COINS, FULL_HEART, FULL_HUNGER, POTION, SCROLL } from "../../../tiles";
import { ALIGN_TYPE, TextType } from "../../../ui/type/TextType";
import { ComponentF, createElement } from "../../../ui/ui";
import Colors from "../../Colors";
import { SpellWand } from "../info/SpellWand";

const WAND_STRING = `%c{${Colors.LIGHT_GRAY_2}}This is your wand, the letters here you can use to make words. Type to place letters. %c{${Colors.GREEN_3}}Enter%c{${Colors.LIGHT_GRAY_2}} to play the word. Words must connect to your PLAYER and spell valid words.`;

const ATTACK_STRING = `%c{${Colors.LIGHT_GRAY_2}}Use an opponent's letters to form a word to remove their %c{${Colors.PINK_4}}${FULL_HEART}%c{${Colors.LIGHT_GRAY_2}}`;

const HEALTH_HUNGER_STRING_1 = `%c{${Colors.LIGHT_GRAY_2}}Lose all of your %c{${Colors.PINK_4}}${FULL_HEART}%c{${Colors.LIGHT_GRAY_2}} and you lose the game. Playing short words will reduce your %c{${Colors.SEA_GREEN_4}}${FULL_HUNGER}%c{${Colors.LIGHT_GRAY_2}}. If you run out of %c{${Colors.SEA_GREEN_4}}${FULL_HUNGER}%c{${Colors.LIGHT_GRAY_2}} you will lose a %c{${Colors.PINK_4}}${FULL_HEART}%c{${Colors.LIGHT_GRAY_2}}.`;

const COIN_STRING = `%c{${Colors.LIGHT_GRAY_2}}Collect %c{${Colors.YELLOW_1}}${COINS}%c{${Colors.LIGHT_GRAY_2}} To Purchase Spells. %c{${Colors.GREEN_3}}Tab%c{${Colors.LIGHT_GRAY_2}} to open the spell list.`;

const ITEM_STRING = `%c{${Colors.LIGHT_GRAY_2}}Collect %c{${Colors.PEACH_1}}${SCROLL}%c{${Colors.LIGHT_GRAY_2}} and %c{${Colors.PURPLE_3}}${POTION}%c{${Colors.LIGHT_GRAY_2}}. They will help you in your quest.`;

const PICKUP_STRING = `%c{${Colors.LIGHT_GRAY_2}}Defeating all opponents will pick up remaining %c{${Colors.YELLOW_1}}${COINS}%c{${Colors.PEACH_1}}${SCROLL}%c{${Colors.PURPLE_3}}${POTION}`;

export const HelpComponent: ComponentF<{ live: boolean }> = (C, { live }) => {
  return [
    createElement(
      SpellWand,
      { x: 0, y: 1, w: C.bounds.w, h: 1 },
      { static: live ? null : "XOPLTEIM" }
    ),
    createElement(
      TextType,
      { x: 0, y: 3, w: C.bounds.w, h: 1 },
      { title: WAND_STRING }
    ),

    createElement(
      TextType,
      { x: 0, y: 8, w: C.bounds.w, h: 1 },
      { title: "ATTACKING", align: ALIGN_TYPE.center }
    ),
    createElement(
      TextType,
      { x: 0, y: 9, w: C.bounds.w, h: 1 },
      { title: ATTACK_STRING }
    ),

    createElement(
      TextType,
      { x: 0, y: 10, w: C.bounds.w, h: 1 },
      { title: HEALTH_HUNGER_STRING_1 }
    ),

    createElement(
      TextType,
      { x: 0, y: 14, w: C.bounds.w, h: 1 },
      { title: "ITEMS & SPELLS", align: ALIGN_TYPE.center }
    ),
    createElement(
      TextType,
      { x: 0, y: 15, w: C.bounds.w, h: 1 },
      { title: COIN_STRING }
    ),

    createElement(
      TextType,
      { x: 0, y: 16, w: C.bounds.w, h: 1 },
      { title: ITEM_STRING }
    ),

    createElement(
      TextType,
      { x: 0, y: 17, w: C.bounds.w, h: 1 },
      { title: PICKUP_STRING }
    ),
  ];
};
